/* eslint-disable react/no-danger */
/**
 * 移动重新搜索面板
 * 
 * @Author: Focci
 * @Date: 2023-08-01 16:05:04
 * @Last Modified by: Focci
 * @Last Modified time: 2023-08-01 16:05:04
 */

'use client'

// import PropTypes from 'prop-types'
import CheckboxIcon from '@img/checkbox-icon.svg'
import { useCallback, useEffect } from 'react'
import { useTranslations } from 'next-intl'
import { Checkbox } from '@comp/material'
import { useMapState } from '@comp/mapbox'
import { cookieGet, cookieSet } from '@lib/utils'

export default function MoveResearchCheckbox() {
  const ts = useTranslations('search')
  const { enabledMoveResearch, setEnabledMoveResearch, setIsMapMoved } = useMapState()
  const cookieName = 'HG_ENABLED_MOVE_RESEARCH'

  const handleChange = useCallback((e) => {
    setEnabledMoveResearch(e.target.checked)
    setIsMapMoved(false)
    cookieSet(cookieName, e.target.checked ? '1' : '')
  }, [setEnabledMoveResearch, setIsMapMoved])

  // 设置是否开启移动重新搜索
  useEffect(() => {
    const timer = setTimeout(() => {
      const enable = cookieGet(cookieName)
      setEnabledMoveResearch(enable === null ? true : !!enable)
    }, 2000)
    
    return () => timer && clearTimeout(timer)
  }, [setEnabledMoveResearch])
  
  return (
    <label
      className="
        bg-primary text-white rounded-md p-2 shadow-large cursor-pointer
        flex items-center pointer-events-auto
      "
    >
      <Checkbox
        checked={enabledMoveResearch}
        onChange={handleChange}
        color="light"
        icon={<CheckboxIcon />}
        sx={{ color: 'white' }}
      />
      <span 
        className="ml-1 leading-tight" 
        dangerouslySetInnerHTML={{ __html: ts('moveMapResearch') }}
      />
    </label>
  )
}

// MoveResearchCheckbox.propTypes = {
//   onResearch: PropTypes.func,
// }
